import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type NetworkErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;

/**
 * The request was sent and nothing came back.
 *
 * Sentry MYFITWORLD-V2-6Q/-6R: this used to be an `InternalServerError`, which is a claim
 * about the SERVER — and the server had in fact answered that same request with 200. The
 * caller was an iPhone whose tab went to the background mid-boot, so iOS killed the XHR.
 * Reported as a 500 it became indistinguishable from a backend refusing the session, and
 * the session guard duly armed a hard cooldown and told the user their session was over.
 *
 * A `BaseApiResponseError` on purpose, so every existing consumer — the toast predicate
 * above all — keeps behaving exactly as it did. What changes is only that the failure can
 * now be RECOGNISED: `status` is `NoResponse`, the same 0 the browser itself reports for
 * an aborted request, rather than a status no server ever sent.
 */
export default class NetworkError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ message }: NetworkErrorArgs<TErrors>) {
    super({ errors: null, message, status: HttpStatus.NoResponse });
  }
}
